import * as B from '@blueprintjs/core';
import React from 'react';

import {ConversionWarnings} from 'app/modules/Remote/Admin/types';

import {CollapsibleImpactCallout} from './CollapsibleImpactCallout';
import {ImpactedPropertyLinks} from './ImpactedPropertyLinks';

export const LookoutsImpactCallout: React.FunctionComponent<{
  conversionWarnings: ConversionWarnings | null;
}> = ({conversionWarnings}) => {
  const properties = conversionWarnings?.LOOKOUTS_WARNING?.lookouts ?? [];

  if (properties.length === 0) return null;

  const propertyCount = new Set(properties.map((p) => p.featureId)).size;

  return (
    <CollapsibleImpactCallout
      intent={B.Intent.WARNING}
      title="Lookouts Notice"
      summary={`This update will reset Lookouts on ${propertyCount} ${
        propertyCount === 1 ? 'property' : 'properties'
      }.
`}
    >
      <div>
        Your updated properties will still be enrolled in Lookouts. They will be re-checked once the
        property has reprocessed, so you may get new notifications for conditions that were already
        alerting.
      </div>
      <strong>Affected properties:</strong> <ImpactedPropertyLinks properties={properties} />
    </CollapsibleImpactCallout>
  );
};
